import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { UpcomingMeetings } from "../components/UpcomingMeetings"

export function ServiceCenterMeetingService() {
    return (
        <>
            <LocalizedStrict id="service-center-reports-upcoming-meetings-title" attrs={{ title: true }}>
                <PageHeader page={Page.SERVICE_CENTER_REPORTS_MEETING_SERVICE_ROUTE} title="Upcoming meetings" />
            </LocalizedStrict>
            <UpcomingMeetings />
        </>
    )
}
